// ==================== NOT FOUND PAGE ====================

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Search, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import GradientBox from '../../components/ui/GradientBox';
import CustomButton from '../../components/ui/CustomButton';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: colors.background.gradient,
        padding: 3,
      }}
    >
      <GradientBox
        glass
        sx={{
          padding: 4,
          textAlign: 'center',
          maxWidth: 500,
          borderRadius: 3,
        }}
      >
        <Search
          size={80}
          color={colors.info.main}
          style={{ marginBottom: 24 }}
        />

        <Typography variant="h3" gutterBottom sx={{ fontWeight: 600 }}>
          Page Not Found
        </Typography>

        <Typography variant="h6" color="textSecondary" sx={{ mb: 3 }}>
          The page you're looking for doesn't exist
        </Typography>

        <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
          It might have been moved, deleted, or you entered the wrong URL.
        </Typography>

        <CustomButton
          variant="gradient"
          gradient="primary"
          startIcon={<Home size={20} />}
          onClick={() => navigate('/')}
          size="large"
        >
          Go Home
        </CustomButton>
      </GradientBox>
    </Box>
  );
};

export default NotFoundPage;
